import { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';
import { MIME_TYPES } from '@callmart/types';

// Re-export for backward compatibility
export const XLSX_CONTENT_TYPE = MIME_TYPES.XLSX;

export const extractFileName = (headers: RawAxiosResponseHeaders | AxiosResponseHeaders): undefined | string => {
    const contentDisposition = headers['content-disposition'];
    // trying to extract filename from content-disposition header
    if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
            return decodeURIComponent(match[1]);
        }
    }
    return undefined;
};

export const extractContentType = (headers: RawAxiosResponseHeaders | AxiosResponseHeaders): undefined | string => {
    const contentType = headers['content-type'];
    return typeof contentType === 'string' ? contentType : undefined;
};
